export default "__VITE_ASSET__EUM3kqfo__"